// Every line terminator, not just \n: \r and the Unicode separators would otherwise let a
// server-supplied value paint several visual lines into a banner.
const LINE_BREAK = /[\r\n\u2028\u2029]/;

/**
 * A server string fit to put on screen, or null.
 *
 * `error`, `message` and `GeneralErrorMessage` are not a sanitised public contract: an unhandled
 * 5xx can put an exception dump or an internal identifier in any of them. A curated message is one
 * short line, so anything else falls back to the generic text and survives only in the api-error
 * telemetry, which still records the untruncated value.
 */
const curated = value => typeof value === 'string' && value.length > 0 && value.length <= 200 && !LINE_BREAK.test(value) ? value : null;
export const generateServerResponseErrorText = function (errors, entity) {
  var _curated, _details$GeneralError, _details$FieldErrorMe;
  let correlationId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  const commonErrorText = 'Error';

  // Services that answer `{ error: "<message>" }` and the API gateway's `{ message: "..." }` hand us
  // a bare string. Without this it falls through to the generic branch and the real reason is lost,
  // which is how a configuration failure renders as "Error / Error".
  const details = typeof entity === 'string' ? curated(entity) && {
    GeneralErrorMessage: entity
  } || null : entity;
  if (errors) {
    let errorText = '';
    // eslint-disable-next-line @typescript-eslint/no-loop-func
    for (const key in errors) if (errors.hasOwnProperty(key)) errors[key].forEach(err => errorText += err);
    return {
      title: commonErrorText,
      body: [errorText]
    };
  }
  if (!details) {
    // The correlation id survives even when the message does not. A bare string gated away from a
    // customer, or an uncurated one, lands here with details null - and dropping the id too left
    // them reading "Error / Error" with nothing support could search on. This is the global toast
    // path, so that was every gated error in the app, not only the credential lookups.
    return {
      title: commonErrorText,
      body: correlationId ? [commonErrorText, "\n\nError code: ".concat(correlationId)] : [commonErrorText]
    };
  }
  const errorTitle = (_curated = curated((_details$GeneralError = details.GeneralErrorMessage) !== null && _details$GeneralError !== void 0 ? _details$GeneralError : details.generalErrorMessage)) !== null && _curated !== void 0 ? _curated : commonErrorText;
  const fieldsErrors = (_details$FieldErrorMe = details.FieldErrorMessages) !== null && _details$FieldErrorMe !== void 0 ? _details$FieldErrorMe : details.fieldErrorMessages;
  const fieldsErrorsArray = [];
  if (fieldsErrors === null) {
    return {
      title: commonErrorText,
      body: [errorTitle]
    };
  }
  for (const key in fieldsErrors) {
    if (fieldsErrors.hasOwnProperty(key)) {
      fieldsErrors[key].map(err => {
        var _err$Message, _err$Message2, _err$ErrorCode;
        fieldsErrorsArray.push(((_err$Message = err.Message) !== null && _err$Message !== void 0 ? _err$Message : err.message) ? (_err$Message2 = err.Message) !== null && _err$Message2 !== void 0 ? _err$Message2 : err.message : (_err$ErrorCode = err.ErrorCode) !== null && _err$ErrorCode !== void 0 ? _err$ErrorCode : err.errorCode);
      });
    }
  }
  if (correlationId) {
    fieldsErrorsArray.push("\n\nError code: ".concat(correlationId));
  }
  return {
    title: errorTitle,
    body: [fieldsErrorsArray]
  };
};